import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default class Vehicles extends Component {

constructor(props)
{
	console.log(props);
	super(props);

	this.state =
	{
		vehiclesObject: {},
		vehicles: [],
		identityPrincipal : props.identityPrincipal
	};
}



componentDidMount()
{
	this.handleOnLoad();
}

handleOnLoad = () => {

	if (!this.state.identityPrincipal){
		var queryUrl = `${global.config.securityServicesUrl}/user-profile-service/email/${this.props.userId}`;
 		console.log('up url = ' + queryUrl);
		axios.get(queryUrl).then(response => {
		console.log('setting idp - ' + response.data);
		this.setState({identityPrincipal : response.data});	
		console.log('set idp - ' + JSON.stringify(this.state));
		}).catch(function (error){
			console.log(error);
		});	
	}
	
	let data = {};
	let url = `${global.config.dataServicesUrl}/gazelle/Vehicles/identityPrincipal/${this.state.identityPrincipal}`;
	console.log(url);
  	axios.get(url).then(res => {
  	const vehicles = res.data;
  	console.log(vehicles);
  	this.setState({ vehicles : res.data });
	});
}
handleDelete(event){
	event.preventDefault();
	let url = `${global.config.dataServicesUrl}/gazelle/Vehicles/id/${event.target.id}`;
	console.log(url);
// 	let data = "{ \"_id\" : \"" + event.target.id + "\"}";
// 	console.log('deleting with filter var -> ' + data);
	axios.delete(url).then(res => {
  	
//   		console.log("response.data");
		console.log(res.status +":"+JSON.stringify(res.data));
		if (res.status === 200 )
		{
			this.message = "Success";
		}
		else
		{
			this.message = "Failed";
		}        
		console.log(this.message);
		//this.handleOnLoad();
	}).catch(err => {
		console.log("error - " + err);
	});
	window.location.href = '/vlm-homepage';	
}

render(){

return (


				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="index.html" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="index.html" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
							<br />
							<div class="row">
														<h3 class="col-sm-2 m-widget1__title">
															Vehicles
														</h3>
														<input class="form-control input-xlarge col-sm-6" placeholder="Filter" />&nbsp;
														<a href="/create-vehicle" class="col-sm-2 btn btn-success">Create Vehicle</a> 
							</div>
							<br />
	<table class="oux_table table table-striped table-bordered table-hover" id="list" border="1" var="item" rows="20"  value="#{ombCustomerForm.searchResults }">

			<thead>
				<tr>
					<th scope = "col">Id</th>
					<th scope = "col">Name</th>
					<th scope = "col">Description</th>
					<th scope = "col">Actions</th>
				</tr>
			</thead>

			<tbody>
				{this.state.vehicles.map( ( {id, name, description} ) => {

					return	<tr>

							
							<td><Link  to={{ pathname: "/manage-vehicle", search : `?id=${id}` }}>{id}</Link></td>
							<td><Link  to={{ pathname: "/manage-vehicle", search : `?id=${id}` }}>{name}</Link></td>
							<td><Link  to={{ pathname: "/manage-vehicle", search : `?id=${id}` }}>{description}</Link></td>
							<td>

								<button class="btn btn-danger btn-sm" id={id} onClick={this.handleDelete}>Delete</button>
							</td>
						</tr>


				})
			}

			</tbody>


		</table>

						</div>            
					</div>		

	            </div>	
            </div>
            
			</div>
			</div>
			



);
}
}

